import { CookieStorage } from "cookie-storage";
import { LocalDateTime, convert } from "js-joda";
import * as log from "loglevel";
import { UserManager, Log, WebStorageStateStore } from "oidc-client";

import { authentication, generalApiSettings, mainApi, cacheApi, settings } from "config";
import { IAppInfo } from "infrastructure";
import { ApplicationApi, registerHttpClientFor } from "infrastructure/http";
import { setUpLocalizationSettings } from "infrastructure/localization";

export const configureLogging = () => {
  const logLevel = process.env.REACT_APP_LOG_LEVEL || "ERROR";

  log.setLevel(logLevel as log.LogLevelDesc);
};

configureLogging();

export const configureLocalization = () => {
  setUpLocalizationSettings(settings.localization);
};

configureLocalization();

export const configureHttpClients = (unauthorizedHandler: () => void) => {
  registerHttpClientFor(
    new ApplicationApi({
      name: mainApi.name,
      url: mainApi.url,
      authenticationScheme: generalApiSettings.authenticationScheme,
      unauthorizedHandler: unauthorizedHandler
    })
  );

  registerHttpClientFor(
    new ApplicationApi({
      name: cacheApi.name,
      url: cacheApi.url,
      authenticationScheme: generalApiSettings.authenticationScheme,
      unauthorizedHandler: unauthorizedHandler
    })
  );
};

export const getAppInfo = (): IAppInfo => {
  return {
    appName: process.env.REACT_APP_NAME ? process.env.REACT_APP_NAME : "app name not defined",
    version: process.env.REACT_APP_SHOW_VERSION === "1" ? process.env.REACT_APP_VERSION : undefined,
    company: process.env.REACT_APP_LICENSE ? process.env.REACT_APP_LICENSE : "app copyright not defined"
  };
};

export const getApplyThemeHandler = () => {
  return (theme: string) => {
    const rootElement = document.getElementsByTagName("body")[0];

    if (rootElement) {
      rootElement.className = theme;
    }
  };
};

export const getUserManager = () => {
  const parseLogLevel = (logLevel: string | undefined): number => {
    const authLogLevel = logLevel || "";
    const result = Log[authLogLevel];

    return result || Log.NONE;
  };

  Log.logger = console;
  Log.level = parseLogLevel(process.env.REACT_APP_AUTH_LOG_LEVEL);

  const settings = {
    ...authentication.authenticationServiceSettings,
    stateStore: new WebStorageStateStore({
      store: new CookieStorage({
        sameSite: "Lax",
        expires: convert(LocalDateTime.now().plusMinutes(5)).toDate(),
        path: "/"
      })
    })
  };

  return new UserManager(settings);
};
